import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { ILightGalleryItemProps } from '../types'

const Image = styled.img`
  object-fit: cover;
`

/** Item для LightGalleryItem */
const LightGalleryItem: FC<ILightGalleryItemProps> = (props) => {
  const { src, thumb, subHtml, alt, width, height, children, ...otherProps } = props

  return (
    <>
      <a href={src} data-sub-html={subHtml} {...otherProps} rel='nofollow'>
        {children}
        <Image
          src={thumb || src}
          alt={alt || 'Изображение'}
          width={width}
          height={height}
          loading='lazy'
        />
      </a>
    </>
  )
}

export { LightGalleryItem }
export default memo(LightGalleryItem)
